<template>
  <lb-drawer
    :value="value"
    @input="$emit('input', $event)"
    :heading="heading"
    width="500"
    persistent
  >
    <template v-slot:body>
      <DragDropfile
        hidedetails
        :files="files"
        @update:files="$emit('update:files', $event)"
        :resetTrigger="resetTrigger"
        data-testid="manual-match-drawer__upload"
      />
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <div>
        <div>
          <v-btn
            data-testid="manual-match-drawer__submit-button"
            class="ml-2"
            color="primary"
            @click="$emit('submit')"
          >
            <span>Submit</span>
          </v-btn>
        </div>
      </div>
    </template>
  </lb-drawer>
</template>

<script>
import DragDropfile from '../../../../../../views/Inputs/DragDropfile.vue';

export default {
  name: 'ManualMatchDrawer',
  components: {
    DragDropfile,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: 'Manual Matching',
    },
    files: {
      type: [Array, Object, File],
      default: null,
    },
    resetTrigger: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
